var ctrlopt = ctrlopt;
var google = google;
var site = site;
var generic = generic;

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var apptBookingSettings = Drupal.settings.appointment_booking_variables || {};
  var disableCounterAutoselect = apptBookingSettings.disable_counter_autoselect || 0;
  var location_group_dropdown_enabled_inc = apptBookingSettings.show_city_drop_down_apptbk !== 'undefined' ? apptBookingSettings.show_city_drop_down_apptbk : 0;

  /* Concrete View */
  apptBook.LocationSelectSection = function (container) {
    apptBook.LocationSelectSection.superclass.constructor.call(this);
    this.id = 'counters';
    this.haveDistances = false;
    this.searchLoc = {};
    this.userLoc = null;
    this.mapZoomLevel = 13;
    this.container = container;
    this.submitted = false;
    this.selectMenu = container.find('select.js-location-select');
    this.locationGroupMenu = container.find('select.js-location-group-select');
    this.locationGroupDropdownEnabledCMS = this.locationGroupMenu.length;
    this.locationSelectContainer = container.find('.js-appointment-booking-location-select-v2');
    this.locationGroupType = this.locationSelectContainer.data('additional-location-select-dropdown-type');
    this.enableGeolocation = this.locationSelectContainer.data('enable-geolocation');
    this.geoLocationCountry = this.locationSelectContainer.data('geolocation-country') ? container.find('.js-appointment-booking-location-select-v2').data('geolocation-country') : 'United States';
    this.submitBtn = container.find('.js-location-submit');
    this.geoLocBtn = container.find('.js-geo_search-btn');
    this.signinMessage = container.find('.js-appt-book-location__signin-text');
    this.boundTransIn = this.onTransIn.bind(this);
    this.initialized = false;
    this.stores = {};
    this.locationMenuStores = [];
    this.selectedInfoCounterId = null;
    this.map = null;
    this.infoWindow = null;
    this.markers = [];
    this.locationGroupData = [];
    this.isLoadGoogleAsync = false;
  };

  ctrlopt.extend(apptBook.LocationSelectSection, apptBook.AbstractSection);

  apptBook.LocationSelectSection.prototype.sortAndBuildLocationGroupMenuByDist = function () {
    var $siblinglocationGropMenu;

    this.locationGroupData.sort(function (a, b) {
      return a.dist - b.dist;
    });
    var currentSelection = this.locationGroupMenu.val(); // Save current selection to reselect after rebuild

    $(this.locationGroupMenu).find('option').not(':first').remove();
    for (var i = 0; i < this.locationGroupData.length; i++) {
      var locationGroup = this.locationGroupData[i];
      var newOption = $('<option value="' + locationGroup.optionMenuString + '">' + locationGroup.optionMenuString + '</option>');

      this.locationGroupMenu.append(newOption);
    }
    this.locationGroupMenu.val(currentSelection);
    $siblinglocationGropMenu = this.locationGroupMenu.siblings('a.selectBox-dropdown');
    if (!site.client.isMobile && this.locationGroupMenu.hasClass('selectbox') && $siblinglocationGropMenu.length) {
      this.locationGroupMenu.selectBox('refresh');
    }
  };

  apptBook.LocationSelectSection.prototype.getHaversineDist = function (lat1, lng1, lat2, lng2) {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);
    var dLng = deg2rad(lng2 - lng1);

    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km

    return d;
  };

  // Get the location and distance of each locationGroup from this.me.searchLoc
  // and then rebuild the location group dropdown sorted by distance.
  apptBook.LocationSelectSection.prototype.rebuildLocationGroupMenuByDist = function () {
    var j;

    for (j = 0; j < this.countersData.length; j++) {
      var searchString;
      var optionMenuString;
      var locationGroupLat;
      var locationGroupLong;
      var locationGroupDist = 99999; // Default to a very high distance -- this will cause any locationGroups with no location data to sort last

      if (this.countersData[j].is_virtual) {
        continue;
      }
      if (this.locationGroupType === 'county') {
        searchString = this.countersData[j].county;
        optionMenuString = this.countersData[j].county;
        locationGroupLat = this.countersData[j].county_lat;
        locationGroupLong = this.countersData[j].county_lng;
      } else {
        searchString = this.countersData[j].town + ', ' + this.countersData[j].county;
        optionMenuString = this.countersData[j].town;
        locationGroupLat = this.countersData[j].town_lat;
        locationGroupLong = this.countersData[j].town_lng;
      }

      if (locationGroupLat !== '' && locationGroupLong !== '') {
        locationGroupDist = this.getHaversineDist(this.searchLoc.latitude, this.searchLoc.longitude, locationGroupLat, locationGroupLong);
      }

      // Only add this location group to our array if it's not already there.
      var foundOpt = this.locationGroupData.find(function (optionMenuSearchString, thisOpt) {
        return thisOpt.optionMenuString === optionMenuSearchString;
      }.bind(this, optionMenuString)) ? true : false;

      if (!foundOpt) {
        this.locationGroupData.push({
          optionMenuString: optionMenuString,
          searchString: searchString,
          dist: locationGroupDist
        });
      }
    }
    this.sortAndBuildLocationGroupMenuByDist();
  };

  // Build the locationGroup dropdown using either the Cities/Towns or the Countys/States from the countersData
  // If geolocation is enabled, sort by distance, otherwise sort alphabetically.
  apptBook.LocationSelectSection.prototype.buildLocationGroupMenu = function () {
    var me = this;

    if (!this.locationGroupMenu.length) {
      return;
    }
    var optionText = [],
      uniqueLocationGroupVals = [];

    for (var i = 0, len = this.countersData.length; i < len; i++) {
      if (this.countersData[i].is_virtual) {
        continue;
      }
      if (this.locationGroupType === 'county') {
        optionText[i] = this.countersData[i].county;
      } else { // Defaults to using city/town
        optionText[i] = this.countersData[i].town;
      }
    }
    $.each(optionText, function (i, el) {
      if ($.inArray(el, uniqueLocationGroupVals) === -1) {
        uniqueLocationGroupVals.push(el);
        var newOption = $('<option value="' + el + '">' + el + '</option>');

        me.locationGroupMenu.append(newOption);
      }
    });
    sortLocationGroupOptions();

    function sortLocationGroupOptions() {
      var foption = $(me.locationGroupMenu).find('option:first');

      $(me.locationGroupMenu).html($(me.locationGroupMenu).find("option:not(':first-child')").sort(function (a, b) {
        return a.text.toUpperCase() > b.text.toUpperCase() ? 1 : a.text.toUpperCase() < b.text.toUpperCase() ? -1 : 0;
      }));
      $(me.locationGroupMenu).prepend(foption);
    }
    $(this.locationGroupMenu).change(function () {
      $(me.selectMenu).find('option').not(':first').remove();
      if (me.locationGroupMenu.val() === '0' || disableCounterAutoselect) {
        me.buildSelectMenu({
          counterSelect: null,
          selectNone: true
        }); // If the user is selecting NO location group, do not autoselect a counter
      } else {
        me.buildSelectMenu({
          counterSelect: null,
          selectNone: null
        });
      }

      // If the user selected NO location group, then do NOT do any sort of search!
      if (me.locationGroupMenu.val() === '0') {
        return;
      }

      // Create a search string for a counter in the location group...
      var search;

      if (me.locationGroupType === 'city') {
        var firstCounterId = $(me.selectMenu).find('option:eq(1)').val();
        var filteredCounter = me.countersData.find(function (counterId, counter) {
          return counter.id === counterId;
        }.bind(this, firstCounterId));

        search = filteredCounter.town + ', ' + filteredCounter.county;
        if (me.map) {
          me.mapZoomLevel = 13;
        }
      } else {
        search = $(me.locationGroupMenu).val();
        if (me.map) {
          me.mapZoomLevel = 9;
        }
      }

      var geocoder = new google.maps.Geocoder();

      geocoder.geocode(
        {
          'address': search,
          'componentRestrictions': {
            'country': me.geoLocationCountry
          }
        },
        function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            var loc = results[0].geometry.location;

            $(document).trigger('apptbook:selectlocationgroup', loc);
          }
        }
      );
    });
  };

  apptBook.LocationSelectSection.prototype.buildSelectMenu = function (args) {
    var me = this;
    var counterSelect = args['counterSelect'];
    var selectNone = args['selectNone'];
    var findStoreNumber = $('#appointment-book-container').attr('data-virtual_store_querystring_value');
    var storeNumber = me.countersData.find((storeCounter) => (storeCounter.store_no === findStoreNumber ? true : ''));
    var virtualOabButton = $('.js-virtual__appointment--btn');
    this.locationMenuStores = [];
    if (!this.countersData || !this.selectMenu.length) {
      return;
    }

    if (me.haveDistances) {
      me.countersData.sort(function (a, b) {
        if (a.distance > b.distance) {
          return 1;
        }
        if (b.distance > a.distance) {
          return -1;
        }

        return 0;
      });
    }

    var selected_location_group = $(this.locationGroupMenu) && $(this.locationGroupMenu).val() !== '0' ? $(this.locationGroupMenu).val() : 0;
    var virtualList = [];
    var virtualIds = [];

    for (var j = 0, serviceLen = this.model.servicesData.length; j < serviceLen; j += 1) {
      if (this.model.servicesData[j].virtual !== '0') {
        virtualList.push(this.model.servicesData[j].id);
      }
    }
    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var serviceIds = this.countersData[i].service_ids;

      if ($.isArray(serviceIds)) {
        virtualIds = serviceIds.filter(function (e) {
          return virtualList.indexOf(e) !== -1;
        });
      }
      if (typeof virtualIds !== 'undefined' && virtualIds.length > 0) {
        this.countersData[i].is_virtual = 1;
      } else {
        this.countersData[i].is_virtual = 0;
      }

      var selectMatches = false;

      if (this.locationGroupType === 'county') {
        selectMatches = selected_location_group === this.countersData[i].county;
      } else { // Defaults to select by city/town
        selectMatches = selected_location_group === this.countersData[i].town;
      }
      if ((!selected_location_group && typeof virtualIds !== 'undefined' && !virtualIds.length) || ((location_group_dropdown_enabled_inc || this.locationGroupDropdownEnabledCMS) && selectMatches)) {
        var storeName = this.countersData[i].name,
          optionText = this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1,
          optionValue = this.countersData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
          storeNum = this.countersData[i].store_no,
          maxApptDuration = this.countersData[i].max_appointment_duration,
          tSlotInt = this.countersData[i].timeslot_interval;

        this.stores[optionValue] = {
          store: storeNum,
          name: storeName,
          maxApptDuration: maxApptDuration,
          tSlotInt: tSlotInt
        };

        // Don't filter out counters
        // Removed  - BB  Virtual Counter from the select option
        if (this.countersData[i].town !== 'NA') {
          this.selectMenu.append(newOption);
          this.locationMenuStores.push(this.countersData[i]);
        }
      }
    }

    if (!me.haveDistances) {
      sortLocationOptionsByAlpha();
    }

    if (counterSelect) {
      $(me.selectMenu).val(counterSelect);
    } else if (!selectNone) {
      $(me.selectMenu).val(me.countersData[0].id);
    }
    // $(me.selectMenu).selectBox('refresh');
    virtualOabButton.addClass('no_services');
    if (storeNumber) {
      virtualOabButton.removeClass('no_services');
    }

    function sortLocationOptionsByAlpha() {
      var foption = $(me.selectMenu).find('option:first');

      $(me.selectMenu).html($(me.selectMenu).find("option:not(':first-child')").sort(function (a, b) {
        return a.text.toUpperCase() > b.text.toUpperCase() ? 1 : a.text.toUpperCase() < b.text.toUpperCase() ? -1 : 0;
      }));
      $(me.selectMenu).prepend(foption);
    }

    function setSubmitBtnState() {
      $(window).trigger('appt::close_infobox');
      $(window).trigger('appt::reset_markers');
      if (me.selectMenu.val() === '0') {
        me.selectedInfoCounterId = null;
        me.submitBtn.addClass('disabled').attr('tabindex', '-1');
      } else {
        // This is triggered when the selectMenu is updated -- update the map marker if maps are enabled
        if (me.enableGeolocation) {
          var filteredCounter = me.countersData.find(function (counterId, counter) {
            return counter.id === counterId;
          }.bind(this, me.selectMenu.val()));

          if (filteredCounter.marker) {
            new google.maps.event.trigger(filteredCounter.marker, 'click');
          }
        }

        me.submitBtn.removeClass('disabled').removeAttr('tabindex');
        if (site.client.isMobile) {
          if (!me.enableGeolocation && !me.submitted) {
            me.submitted = true;
            me.submitBtn.trigger('click');
          }
        }
      }

      return;
    }

    function selectLocationGroupForCounter() {
      var counterId = me.selectMenu.val();

      if (counterId === '0') {
        return;
      }

      var filteredCounter = me.countersData.find(function (counterId, counter) {
        return counter.id === counterId;
      }.bind(this, counterId));

      if (me.locationGroupType === 'county') { // Select location group
        if ($(me.locationGroupMenu).val() === filteredCounter.county) {
          return;
        }
        $(me.locationGroupMenu).val(filteredCounter.county);
      } else {
        if ($(me.locationGroupMenu).val() === filteredCounter.town) {
          return;
        }
        $(me.locationGroupMenu).val(filteredCounter.town);
      }
      $(me.selectMenu).find('option').not(':first').remove();
      me.buildSelectMenu({
        counterSelect: counterId,
        selectNone: null
      });
      if (me.enableGeolocation) {
        me.handleGeoLoc({
          loc: null,
          onlyShowMap: true,
          sortLocGroupMenu: null
        });
      }
    }
    me.onTransIn();
    setSubmitBtnState();
    this.selectMenu.unbind();
    this.selectMenu.on('change', setSubmitBtnState);
    if (this.locationGroupDropdownEnabledCMS) {
      this.selectMenu.on('change', selectLocationGroupForCounter);
    }
  };

  apptBook.LocationSelectSection.prototype.setGeoLocHandler = function () {
    this.geoLocBtn.click($.proxy(function (e) {
      e.preventDefault();
      $(this.locationGroupMenu).val(0); // If we are re-geolocating to the nearest location, unselect the current location group first
      if (disableCounterAutoselect) {
        this.handleGeoLoc({
          loc: null,
          onlyShowMap: null,
          sortLocGroupMenu: null
        });
      } else {
        this.handleGeoLoc({
          loc: this.userLoc,
          onlyShowMap: null,
          sortLocGroupMenu: null
        });
      }
    }, this));
    $(document).on('apptbook:selectlocationgroup', $.proxy(function (e, geoLoc) {
      var loc = {};

      loc.lat = geoLoc.lat();
      loc.lng = geoLoc.lng();
      this.handleGeoLoc({
        loc: loc,
        onlyShowMap: null,
        sortLocGroupMenu: null
      });
    }, this));
  };

  // Handle getting counter geoinfo from doors table and mapping
  apptBook.LocationSelectSection.prototype.handleGeoLoc = function (args) {
    var onlyShowMap = args['onlyShowMap'];
    var sortLocGroupMenu = args['sortLocGroupMenu'];

    this.haveDistances = true;
    if (args.loc) {
      this.searchLoc.latitude = args.loc.lat;
      this.searchLoc.longitude = args.loc.lng;
    }
    // Loop over the counters and get their distance from this.searchLoc if we have a counter geolocation
    for (var i = 0; i < this.countersData.length; i++) {
      if (this.countersData[i].counter_lat !== '' && this.countersData[i].counter_lng !== '') {
        this.countersData[i].distance = this.getHaversineDist(this.searchLoc.latitude, this.searchLoc.longitude, this.countersData[i].counter_lat, this.countersData[i].counter_lng);

        if (!apptBookingSettings.appt_geo_dist_in_km) { // If not kilometers then we want miles
          this.countersData[i].distance = Math.round((this.countersData[i].distance * 0.62137) * 100) / 100;
        } else {
          this.countersData[i].distance = Math.round(this.countersData[i].distance * 100) / 100;
        }
        this.countersData[i].hasGeo = true;
      } else {
        this.countersData[i].distance = 99999;
      }
      if (this.locationMenuStores.length) {
        updateLocationMenuStores(this.countersData[i], this);
      }
    }
    function updateLocationMenuStores(storeData, me) {
      $.each(me.locationMenuStores, function (i, el) {
        if ($.inArray(el.id, storeData.id) !== -1) {
          el = storeData;
        }
      });
    }

    if (!onlyShowMap) {
      // Remove the counters from the dropdown and rebuild it 
      $(this.selectMenu).find('option').not(':first').remove();
      this.buildSelectMenu({
        counterSelect: null,
        selectNone: !(this.searchLoc.latitude && this.searchLoc.longitude)
      });
      $(this.selectMenu).change();
    }
    // If we have a location group menu at this point, we can sort it by distance (from our location)
    // This only happens once, on pageload
    if (this.locationGroupMenu.length && sortLocGroupMenu) {
      this.rebuildLocationGroupMenuByDist();
    }
    this.showOrUpdateMap();
  };

  apptBook.LocationSelectSection.prototype.showOrUpdateMap = function () {
    var center;

    this.locationMenuStores = this.locationMenuStores || this.countersData;
    var filteredCounter = this.locationMenuStores.find(function (counterId, counter) {
      return counter.id === counterId;
    }.bind(this, $(this.selectMenu).val()));
    var mapBounds = null;

    if ($(this.selectMenu).val() === '0' || !filteredCounter.hasGeo) {
      if (this.searchLoc.latitude && this.searchLoc.longitude) {
        center = new google.maps.LatLng(this.searchLoc.latitude, this.searchLoc.longitude);
      } else {
        // If we have no geolocation for the user, we want to set the map bounds to fit all the displayed counter markers
        for (var i = 0; i < this.locationMenuStores.length; i++) {
          var counter = this.locationMenuStores[i];

          if (counter.counter_lat && counter.counter_lng) {
            if (!mapBounds) {
              mapBounds = new google.maps.LatLngBounds();
            }
            var counterPos = new google.maps.LatLng(counter.counter_lat, counter.counter_lng);

            mapBounds.extend(counterPos);
          }
        }
      }
    } else {
      center = new google.maps.LatLng(filteredCounter.counter_lat, filteredCounter.counter_lng);
    }

    if (this.map) {
      this.addStoresToMap();
      if (mapBounds) {
        this.map.fitBounds(mapBounds);
      } else {
        this.map.setCenter(center);
        this.map.setZoom(this.mapZoomLevel);
      }
    } else { // init the map!
      var mapOptions = {
        zoom: this.mapZoomLevel,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: false
      };

      $('.js-appt-book-location-select-map').show();
      this.map = new google.maps.Map($('#appt_store_map')[0], mapOptions);
      if (mapBounds) {
        this.map.fitBounds(mapBounds);
      }
      this.addStoresToMap();
    }
  };

  apptBook.LocationSelectSection.prototype.addStoresToMap = function () {
    function addInfoWindow(door, me, index) {
      var infoWindow, latLng, marker;
      var map = me.map;
      var index_marker = index + 1;

      // We can only put a pin in the map if we have geo location data
      if (door.hasGeo) {
        var distAbbrev = apptBookingSettings.appt_geo_dist_in_km ? 'km' : 'mi';
        var contentString = '<div class="location_info">' +
          '<div class="location_info-col1">' +
          '<h6 class="store_name">' + door.name + '</h6>' +
          '</div>' +
          '<div class="location_info-col2">' +
          door.address1 + '<br />' +
          door.town + ', ' + door.county + ' ' + door.postcode + '<br />' +
          '<a href="tel:' + door.phone + '">' + door.phone + '</a><br />' +
          '<div class="distance">' + door.distance + distAbbrev + '</div>' +
          '</div>' +
          '</div>';

        if (!me.infoWindow) {
          me.infoWindow = new google.maps.InfoWindow();
        }
        infoWindow = me.infoWindow;
        latLng = new google.maps.LatLng(door.counter_lat, door.counter_lng);
        marker = new google.maps.Marker({
          position: latLng,
          map: map,
          index: index,
          door: door,
          me: me
        });
        if (marker) {
          me.markers[index] = marker;

          marker.setIcon('/media/export/cms/appointment_booking/reskin/icons/circle_white_' + index_marker + '.png');
          marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 2);
          door.marker = marker;
          marker.addListener('click', function () {
            var $siblingSelectMenu;
            var index_marker;

            $(window).trigger('appt::close_infobox'); // Close any (other) open infoWindows first
            // If the infoWindow for this marker is not open, open it.
            index_marker = marker.index + 1;
            $(window).trigger('appt::reset_markers');
            marker.setIcon('/media/export/cms/appointment_booking/reskin/icons/circle_black_' + index_marker + '.png');
            marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 1);

            if (!infoWindow.getMap()) {
              infoWindow.setContent(contentString);
              infoWindow.open(map, marker);
            }
            // But do not proceed further if the selected counter is unchanged.. this can cause a cascade that
            // triggers updates in an infinite loop :)
            if (marker.me.selectedInfoCounterId === marker.door.id) {
              return;
            } else if (marker.door.counter_lat && marker.door.counter_lng) {
              marker.me.map.setCenter(new google.maps.LatLng(marker.door.counter_lat, marker.door.counter_lng));
              marker.me.map.setZoom(marker.me.mapZoomLevel);
            }
            marker.me.selectedInfoCounterId = marker.door.id;

            $(marker.me.selectMenu).val(marker.door.id);
            $(marker.me.selectMenu).change();
            $siblingSelectMenu = marker.me.selectMenu.siblings('a.selectBox-dropdown');
            if (!site.client.isMobile && marker.me.selectMenu.hasClass('selectbox') && $siblingSelectMenu.length) {
              $(marker.me.selectMenu).selectBox('refresh');
            }
            // If we have a locationGroup dropdown, we must make sure to select the correct location group if needed
            // AND rebuild the selectMenu if it changes...
            if (marker.me.locationGroupMenu.length) {
              var newLocationGroup = null;

              if (marker.me.locationGroupType === 'county') {
                if (marker.me.locationGroupMenu.val() !== marker.door.county) {
                  newLocationGroup = marker.door.county;
                }
              } else {
                if (marker.me.locationGroupMenu.val() !== marker.door.town) {
                  newLocationGroup = marker.door.town;
                }
              }
              if (newLocationGroup) {
                marker.me.locationGroupMenu.val(newLocationGroup);
                $(marker.me.selectMenu).find('option').not(':first').remove();
                marker.me.buildSelectMenu({
                  counterSelect: marker.door.id,
                  selectNone: null
                });
              } else {
                $(marker.me.selectMenu).change();
              }
            }

            $(window).on('appt::close_infobox', function () {
              infoWindow.close();
            });
            $(window).on('appt::reset_markers', function () {
              for (var j = 0; j < marker.me.markers.length; j++) {
                var a_marker = marker.me.markers[j];
                var icon_index = j + 1;

                if (a_marker) {
                  a_marker.setIcon('/media/export/cms/appointment_booking/reskin/icons/circle_white_' + icon_index + '.png');
                  a_marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 2);
                }
              }
            });

            // infoWindow style overides for Mac
            google.maps.event.addListener(infoWindow, 'domready', function () {
              var iwOuter = $('.gm-style-iw');
              var iwBackground = iwOuter.prev();

              iwBackground.children(':nth-child(3)').children('div').children('div').attr('style', function (i, s) {
                return s + 'background-color: #000 !important;';
              });
              iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
              iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
              var iwCloseBtn = iwOuter.next();

              iwCloseBtn.css({
                opacity: '1',
                color: '#FFFFFF',
                top: '20px',
                right: '15px'
              }).html('');
              iwCloseBtn.addClass('icon--remove');
              iwCloseBtn.mouseout(function () {
                $(this).css({ opacity: '1' });
              });
            });
          });

          if (marker.door.id === me.selectMenu.val()) {
            new google.maps.event.trigger(marker, 'click');
          }
        }
      }
    }
    // Reset markers maps
    for (var j = 0; j < this.markers.length; j++) {
      if (this.markers[j]) {
        this.markers[j].setMap(null);
      }
    }
    for (var i = 0; i < this.locationMenuStores.length; i++) {
      var door = this.locationMenuStores[i];

      addInfoWindow(door, this, i);
    }
  };

  apptBook.LocationSelectSection.prototype.setSubmitHandler = function () {
    var me = this;

    function onSubmit(e) {
      var updateData,
        select = me.selectMenu[0],
        counterId = select.options[select.selectedIndex].value;

      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }

      if (counterId) {
        if (site.track && typeof site.track.evtView === 'function') {
          site.track.evtLink({
            event_name: 'appointmentBooking_Location',
            event_category: 'appointment booking',
            event_action: 'location chosen',
            event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
          });
        }
        updateData = {
          sectionId: 'next',
          params: {
            sectionId: me.id,
            counterId: counterId,
            maxApptDuration: me.stores[counterId].maxApptDuration,
            timeSlotInterval: me.stores[counterId].tSlotInt,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      }
    }

    this.submitBtn.click(onSubmit);
  };

  apptBook.LocationSelectSection.prototype.onTransIn = function () {
    this.container.find('.selectbox').each(function () {
      var control = $(this).data('selectBox-control');

      if (control && control.length && !site.client.isMobile) {
        $(this).selectBox('refresh');
      }
    });
  };

  apptBook.LocationSelectSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Location Select';

    if (data.sectionId === this.id) {
      apptBook.sectionManager.on('transition_in_start', this.boundTransIn);

      me.isSignedIn = typeof site.userInfoCookie == 'undefined'
                            || _.isUndefined(site.userInfoCookie.getValue('signed_in'))
                            || _.isNull(site.userInfoCookie.getValue('signed_in'))
        ? 0 : site.userInfoCookie.getValue('signed_in');

      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      if (!this.initialized) {
        this.initialized = true;
        this.model.getCounters(function (cData) {
          me.countersData = cData;
          me.buildSelectMenu({
            counterSelect: null,
            selectNone: true
          }); // Do not preselect a counter on load
          if (location_group_dropdown_enabled_inc || me.locationGroupDropdownEnabledCMS) {
            me.buildLocationGroupMenu();
          }
          if (me.isSignedIn > 0) {
            me.signinMessage.hide();
          }
          me.setSubmitHandler();
          if (me.enableGeolocation) {
            var locMapsApiLoad = 'apptMapsApiLoaded';

            loadGoogleScript(locMapsApiLoad);
            // Geolocate on maps api loaded callback
            window.apptMapsApiLoaded = function () {
              me.setGeoLocHandler();
              var sortLocGroupMenu = location_group_dropdown_enabled_inc || me.locationGroupDropdownEnabledCMS;

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                  me.userLoc = {};
                  me.userLoc.lat = position.coords.latitude;
                  me.userLoc.lng = position.coords.longitude;
                  if (disableCounterAutoselect) {
                    me.handleGeoLoc({
                      loc: null,
                      onlyShowMap: null,
                      sortLocGroupMenu: sortLocGroupMenu
                    });
                  } else {
                    me.handleGeoLoc({
                      loc: me.userLoc,
                      onlyShowMap: null,
                      sortLocGroupMenu: sortLocGroupMenu
                    });
                  }
                }, function () {
                  me.handleGeoLoc({
                    loc: null,
                    onlyShowMap: null,
                    sortLocGroupMenu: sortLocGroupMenu
                  });
                });
              } else {
                me.handleGeoLoc({
                  loc: null,
                  onlyShowMap: null,
                  sortLocGroupMenu: sortLocGroupMenu
                });
              }
            };
          }
        });
      }
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundTransIn);
      if (me.enableGeolocation) {
        loadGoogleScript();
      }
    }

    function loadGoogleScript(callbackMethodName) {
      if (!this.isLoadGoogleAsync) {
        var g_lang = this.settings && this.settings.geo_location_lang ? this.settings.geo_location_lang : 'en ENGLISH';
        var g_map_js = '';
        var googleApiKey = this.settings.google_api_key ?? this.settings.generic_google_api_key;
        var callbackParam = callbackMethodName ? '&callback=' + callbackMethodName : '';
        var googleScript = document.createElement('script');
        var firstScript = document.getElementsByTagName('script')[0];

        g_lang = g_lang.substring(0, g_lang.indexOf(' '));
        g_map_js = window.location.protocol + '//maps.googleapis.com/maps/api/js?key=' + googleApiKey + '&libraries=geometry' +
                    '&language=' + g_lang + '&v=3' + callbackParam;
        googleScript.async = true;
        googleScript.src = g_map_js;
        googleScript.type = 'text/javascript';
        firstScript.parentNode.insertBefore(googleScript, firstScript);
        this.isLoadGoogleAsync = true;
      }
    }
  };

  Drupal.behaviors.apptBookLocation = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var $virtualApptBtn = $('.js-virtual__appointment--btn', context);
      var ctaText = $('#appointment-book-container', context).attr('data-virtual_cta_value');

      $virtualApptBtn.val(ctaText);
      var $counterContainer = $('#counters', context);
      var view = new apptBook.LocationSelectSection($counterContainer);

      view.setModel(apptBook.sectionModel).startObserving();
      $virtualApptBtn.on('click', function () {
        var queryValue = $('#appointment-book-container', context).attr('data-virtual_store_querystring_value');

        Drupal.behaviors.apptBook.setVirtual('virtual_oab', 1);
        site.track.evtLink({
          event_name: 'appointmentbooking',
          event_category: 'appointment booking',
          event_action: 'start',
          event_label: 'video appointment'
        });
        if ($(this).hasClass('no_services')) {
          $('.js-virtual-service-message').removeClass('hidden');
        }
        apptBook.jumpToServicesForStore(queryValue);
      });
    },
    attached: false
  };
})(jQuery);
